import { render, staticRenderFns } from "./rechargeMsg.vue?vue&type=template&id=cb060654&scoped=true&"
import script from "./rechargeMsg.vue?vue&type=script&lang=js&"
export * from "./rechargeMsg.vue?vue&type=script&lang=js&"
import style0 from "./rechargeMsg.vue?vue&type=style&index=0&id=cb060654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb060654",
  null
  
)

export default component.exports